import { Alerts, Navbar } from '.';
import { Button, IconButton } from '../forms';
import { ButtonVariantEnum, EnvironmentEnum } from '../../enums';
import { FunctionComponent, useEffect, useState } from 'react';
import { useAlert, useAuth } from '../../hooks';

import { BaseLayoutType } from '../../types';
import { FaPowerOff } from 'react-icons/fa';
import Footer from './Footer';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const LandingLayout: FunctionComponent<BaseLayoutType> = ({ children }): JSX.Element => {
  const PUBLIC_URL = process.env.PUBLIC_URL;
  let listener: any = null;
  const { t } = useTranslation();
  const { authenticated, user, login, logout } = useAuth();
  const { alerts } = useAlert();
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (alerts.length > 0) {
      window.scrollTo(0, 0);
    }
  }, [alerts]);

  useEffect(() => {
    listener = document.addEventListener('scroll', (e) => {
      var scrolledFromTop = document.scrollingElement?.scrollTop;
      if (scrolledFromTop! >= 120) {
        if (!scrolled) {
          setScrolled(true);
        }
      } else {
        if (scrolled) {
          setScrolled(false);
        }
      }
    });
    return () => {
      document.removeEventListener('scroll', listener);
    };
  }, [scrolled]);

  return (
    <div>
      <Navbar
        logoLink={authenticated ? `/eleicoes` : ''}
        logoHashLink={authenticated ? '' : '#apresentacao'}
        transparent={!scrolled}
        fixedTop
      >
        {authenticated ? (
          <div className="d-flex">
            <span className="fw-bold align-middle px-2">{user?.nome}</span>
            <img src={user?.foto} alt="mdo" width="28" height="28" className="rounded-circle" />

            <IconButton
              title={t('label.sair')}
              circle
              className="ms-2 text-white"
              variant={ButtonVariantEnum.WARNING}
              onClick={() => {
                logout(() => navigate('/'));
              }}
              Icon={FaPowerOff}
            />
          </div>
        ) : (
          <Button
            title={t('label.entrar')}
            variant={ButtonVariantEnum.WARNING}
            onClick={() => {
              if (process.env.REACT_APP_ENV === EnvironmentEnum.REVIEW_APP) {
                login(() => navigate('/eleicoes'));
              } else {
                window.location.href = `${process.env.REACT_APP_AUTHSERVER_URL}/oauth/authorize?client_id=sce&scope=personal-read&response_type=code&redirect_uri=${process.env.REACT_APP_REDIRECT_URL}`;
              }
            }}
            className={'text-primary-700 border border-primary'}
          />
        )}
      </Navbar>

      <header className={`section-bg-image fullpage-section d-flex flex-column`} id={'apresentacao'}>
        <Alerts />
        <div className="container-xl section-align-center d-flex align-items-center flex-grow-1">
          <div className="text-center">
            <h1 className="section-heading fw-bold mb-4">{t('label.sistema_cadastro_eleicoes')}</h1>
            <h4 className="section-subheading text-muted mb-4">
              {t('texto.apresentacao_sce')}
              <a href="https://sigeleicao.ufpb.br" className="section-subheading" target="_blank" rel="noreferrer">
                {`${t('label.sigeleicao')}.`}
              </a>
            </h4>
            <Button
              title={t('label.saiba_mais')}
              onClick={() => (window.location.href = '#passos-sistema')}
              className={'border border-white'}
            />
          </div>
        </div>
        <div className="d-flex justify-content-center align-items-center gap-3">
          <img src={`${PUBLIC_URL}${'/assets/images/logo_sti_white.svg'}`} alt="Logo STI" height={'30px'} />{' '}
          {t('label.producao_gsi')}
        </div>
      </header>
      <main>
        <div className="container-fluid px-0">{children}</div>
      </main>
      <Footer />
    </div>
  );
};

export default LandingLayout;
